import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { Transaction } from '@App/redux/slices/reports/ReportsSlice'
import { CopyIcon } from '@App/static/icons/SortIcons'
import { Button } from '@App/ui/crypto_exchange/desktop/components/controls/Button'

import { formatDate, formatTime, useCopyText, useSeeMarket } from '../../model'

import s from './styles.module.scss'

export const TransactionInfo = ({ transaction }: { transaction: Transaction }) => {
  const { copyText } = useCopyText()
  const { seeMarket } = useSeeMarket({ sourceCurrency: 'BTC', targetCurrency: 'EUR' })
  return (
    <div className={s.content}>
      <div className={s.general}>
        <div className={s.top}>
          <div className={cn(s.info)}>
            <div className={s.title}>Status</div>
            <div className={cn(s.value, s.withSubValue)}>
              Processed
              <div className={s.subValue}>
                {formatDate(transaction.transaction_time)} {formatTime(transaction.transaction_time)}
              </div>
            </div>
          </div>
        </div>
        <div className={s.bottom}>
          <div className={cn(s.info, s.border)}>
            <div className={s.title}>Currency</div>
            <div className={s.value}>EUR</div>
          </div>
          <div className={cn(s.info, s.border)}>
            <div className={s.title}>Amount</div>
            <div className={s.value}>
              {getValueWithCurrency(transaction.source.amount.currency, transaction.source.amount.amount)}
            </div>
          </div>
          <div className={s.info}>
            <div className={s.title}>Transaction ID</div>
            <div className={cn(s.value, s.id)}>
              {transaction.front_id} <CopyIcon className={s.icon} onClick={() => copyText(transaction.front_id)} />
            </div>
          </div>
        </div>
        <div className={s.actions}>
          <Button valiant="outlined" onClick={seeMarket}>
            See market
          </Button>
          {transaction.status === 'open' && <Button valiant="text">Edit trade</Button>}
        </div>
      </div>
      <div className={s.history}>
        <div className={s.item}>
          <div className={s.header}>
            <div className={s.time}>
              {formatDate(transaction.transaction_time)} {formatTime(transaction.transaction_time)}
            </div>
            <div className={s.title}>
              Opened
              <div className={cn(s.quantity)}>{transaction.source.amount.amount}</div>
              BTC/EUR
            </div>
          </div>
          <div className={cn(s.info, s.borderTop)}>
            <div className={s.title}>At price</div>
            <div className={s.value}>{transaction.source.amount.amount}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
